import React from "react";
import { Card, Row, Col, Button, Badge } from "react-bootstrap";

export default function Success360Card({ data, handleDelete, handleEdit }) {
  const {
    title,
    description,
    examType,
    costPrice,
    sellingPrice,
    discount,
    expiryDate,
    isPopular,
    statusId,
  } = data;
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const getExamTypeBadge = (examType) => {
    const colors = {
      TOEFL: "primary",
      IELTS: "info",
      PTE: "warning",
      GRE: "success",
      GMAT: "dark",
    };
    return <Badge bg={colors[examType] || "secondary"}>{examType}</Badge>;
  };

  return (
    <Col xs={12} md={6} lg={4} className="mb-4">
      <Card className="h-100 shadow-sm">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div className="d-flex flex-column">
            <Card.Title className="mb-1 fs-5">{title}</Card.Title>
            {getExamTypeBadge(examType)}
          </div>
          <div className="d-flex flex-column align-items-end">
            {isPopular && (
              <Badge bg="warning" className="mb-1">
                Popular
              </Badge>
            )}
          </div>
        </Card.Header>

        <Card.Body className="d-flex flex-column">
          <Card.Text className="text-muted mb-3 flex-grow-1">
            {Array.isArray(description) ? description.join(", ") : description}
          </Card.Text>

          <div className="mb-3">
            <Row className="text-center">
              <Col>
                <div className="fw-bold text-primary fs-5">{sellingPrice}</div>
                <small className="text-muted">Selling Price</small>
              </Col>
              <Col>
                <div className="fw-bold text-success fs-5">{discount}</div>
                <small className="text-muted">Discount</small>
              </Col>
            </Row>
            <hr />
            <div className="text-center">
              <div className="fw-bold text-secondary">
                Original:{" "}
                <span className="text-decoration-line-through">
                  {costPrice}
                </span>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <small className="text-muted">Expiry Date:</small>
            <div className="fw-bold">{formatDate(expiryDate)}</div>
          </div>
        </Card.Body>

        <Card.Footer>
          <Row>
            <Col>
              <Button
                variant="outline-primary"
                className="w-100 rounded-pill"
                onClick={() => handleEdit(data)}
              >
                <i className="bi bi-pencil-square me-1"></i>
                Edit
              </Button>
            </Col>
            <Col>
              <Button
                variant="outline-danger"
                className="w-100 rounded-pill"
                onClick={(e) => handleDelete(e, data)}
              >
                <i className="bi bi-trash me-1"></i>
                Delete
              </Button>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </Col>
  );
}
